<div id="radarCharts" class="chartsWrap"></div>



// WEBPACK FOOTER //
// ./src/app/app-charts/app-charts.component.html